// The file contents for the current environment will overwrite these during build.
import packageJson from '../package.json';

export const environment = {
  production: false,
  native: false,
  version: packageJson.version,
  baseUrl: location.origin,
};
